// Generated file : do not modify
export enum PaieStatuts
{
  NONE = 0,
  CREATED,
  GENERATED,
  PRE_IN_CART,
  PRE_PAYED,
  PRE_COUNTED,
  WAITING_PES,
  WAITING_END,
  APPROVED,
  IN_CART,
  PAYED,
  WAITING_PARAM,
  COUNTED,
  CANCELLED,
  MODIFIED
};

import { RubriquePaie } from '@/extend/classes/Rubrique';
import { VariablePaie } from '@/extend/classes/Rubrique';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Paies
export class Recap {
  // Montant
  public montant: number;
  // Cumul artiste
  public cumulArtiste: number;
  // Cumul technicien
  public cumulTech: number;
  // Cumul
  public cumul: number;

  constructor() {
    this.montant = 0;
    this.cumulArtiste = 0;
    this.cumulTech = 0;
    this.cumul = 0;
  }
}

export class SynthesePaie {
  // Salaire brut
  public brut: Recap;
  // Salaire net imposable
  public netImposable: Recap;
  // Nombre d'heures
  public heures: Recap;
  // Heures exonées
  public heuresExo: Recap;
  // Prélèvement à la source
  public pas: Recap;
  // Nombre de cachets
  public cachets: Recap;
  // Brut abattu
  public brutAbattu: Recap;
  // Tranche A Sécutité Sociale
  public trancheASecu: Recap;
  // Plafond Sécutité Sociale
  public plafondSecu: Recap;
  // coût employeur
  public coutEmployeur: Recap;
  // Charge salariales
  public cotisationsSalariales: number;
  // Charge patronales
  public cotisationsEmployeur: number;
  // Salaire net avant prélèvement à la source
  public netAvantImpots: number;
  // Salaire net social
  public netSocial: number;
  // Salaire net à payer
  public netAPayer: number;
  // Base du prélèvement à la source
  public basePas: number;
  // Taux de prélèvement à la source
  public tauxPas: number;
  // Evolution de la rémunération liée à la suppression des cotisations chômage et maladie
  public suppCotisChomageMaladie: number;
  // Taux de prélèvement personnalisé
  public pasPerso: boolean;
  // Frais de salaire
  public frais: number;
  // Acompte
  public acompte: number;
  // Avantage net
  public avantageNet: number;
  // Trop versé au salarié
  public tropVerse: number;
  // Frais de dossier
  public dossier: number;
  // Frais de traitement
  public traitement: number;
  // coût total
  public total: number;
  // Numéro AEM
  public NumeroAEM: number;
  // Réduction URSSAF
  public reducUrssaf: number;
  // Réduction AUDIENS
  public reducAudiens: number;
  // Réduction France Travail
  public reducPE: number;
  // CSG-RDS
  public csgRds: number;
  // Tranche B
  public ta: number;
  // Tranche B
  public tb: number;
  // Réduction base salarié
  public reducBasSal: number;

  constructor() {
    this.brut = new Recap();
    this.netImposable = new Recap();
    this.heures = new Recap();
    this.heuresExo = new Recap();
    this.pas = new Recap();
    this.cachets = new Recap();
    this.brutAbattu = new Recap();
    this.trancheASecu = new Recap();
    this.plafondSecu = new Recap();
    this.coutEmployeur = new Recap();
    this.cotisationsSalariales = 0;
    this.cotisationsEmployeur = 0;
    this.netAvantImpots = 0;
    this.netSocial = 0;
    this.netAPayer = 0;
    this.basePas = 0;
    this.tauxPas = 0;
    this.suppCotisChomageMaladie = 0;
    this.pasPerso = false;
    this.frais = 0;
    this.acompte = 0;
    this.avantageNet = 0;
    this.tropVerse = 0;
    this.dossier = 0;
    this.traitement = 0;
    this.total = 0;
    this.NumeroAEM = 0;
    this.reducUrssaf = 0;
    this.reducAudiens = 0;
    this.reducPE = 0;
    this.csgRds = 0;
    this.ta = 0;
    this.tb = 0;
    this.reducBasSal = 0;
  }
}

export class ModifiedPaie {
  // Id paie modifiée
  public modifiedId: number;
  // Id item factuuré
  public billItemId: number;
  // Code contrat paie modifiée
  public codeContrat: number;
  // Salaire net payé
  public netPaye: number;
  // Prélèvement à la source payé
  public pasPaye: number;
  // Base du prélèvement à la source payé
  public basePasPaye: number;
  // BillItem de la paie
  public billItem: number;
  // Frais de dossier de paie facturés
  public dossier: number;
  // Frais de traitement de paie facturés
  public traitement: number;

  constructor() {
    this.modifiedId = 0;
    this.billItemId = 0;
    this.codeContrat = 0;
    this.netPaye = 0;
    this.pasPaye = 0;
    this.basePasPaye = 0;
    this.billItem = 0;
    this.dossier = 0;
    this.traitement = 0;
  }
}

export class SimuData {
  // Salaire brut
  public brut : number;
  // Salaire net avant impôts
  public netAvantImpots: number;
  // Coût employeur
  public coutEmployeur: number;
  // Charges salariales
  public cotisationsSalariales: number;
  // Charges patronales
  public cotisationsEmployeur: number;
  // Cotisations
  public cotisations: Cotisation[];

  constructor() {
    this.brut  = 0;
    this.netAvantImpots = 0;
    this.coutEmployeur = 0;
    this.cotisationsSalariales = 0;
    this.cotisationsEmployeur = 0;
    this.cotisations = [];
  }
}

export class Cotisation {
  // code
  public code: number;
  // Nom
  public label: string;
  // type
  public type: string;
  // Groupe pour test
  public group: string;
  // Base
  public rBase: number;
  // Assiette
  public assiette: number;
  // Taux salarial
  public tauxSalarial: number;
  // Taux patronal
  public tauxPatronal: number;
  // Nombre pour état des charges
  public nombre: number;
  // Caisse de collecte
  public caisseId: number;

  constructor() {
    this.code = 0;
    this.label = '';
    this.type = '';
    this.group = '';
    this.rBase = 0;
    this.assiette = 0;
    this.tauxSalarial = 0;
    this.tauxPatronal = 0;
    this.nombre = 0;
    this.caisseId = 0;
  }
}

export default class Paie  {
  // Identifiant unique
  public id: number;
  // Généré par 98
  public ci98: boolean;
  // Contrat associé
  public contratId: number;
  // Code contrat 98
  public codeContrat: number;
  // Id projet
  public projetId: number;
  // Rubriques de paie
  public rubriques: RubriquePaie[];
  // Variables de paie
  public variables: VariablePaie[];
  // Synthèse de la paie
  public synthesePaie: SynthesePaie;
  // Information de la paie modifiée
  public modifiedPaie: ModifiedPaie;
  // 
  public cotisations: Cotisation[];
  // 
  public simuData: SimuData;
  // Salarié associé
  public salarieId: number;
  public statut: PaieStatuts;
  // La paie est valide
  public valide: boolean;
  // Date debut
  public dateDebut: Date;
  // Date fin
  public dateFin: Date;
  // La paie béneficie de l'exoneration apprentis'
  public exoApprentis: boolean | null;
  // Date de règlement par l'employeur
  public dateReglement: Date | null;
  // Date de paiement au salarié
  public datePaiement: Date | null;
  // Salarié
  public salarie: string;
  // Etablissement
  public etablissement: string;
  // Date d'approbation
  public approvedAt: Date | null;
  // Date d'annulation
  public cancelledAt: Date | null;
  // Les données à renseigner par l'employeur sont toutes présentes
  public userCompleted: boolean;
  // Les données à renseigner par le salarié sont toutes présentes
  public salarieCompleted: boolean;
  // Le bulletin de paie doit être soumis par l'employeur
  public toSubmit: boolean;
  // Le document associé possède une version avec des révisions pour l'employeur
  public hasUserUpdate: boolean;
  // Le document associé possède une version avec des révisions pour le salarié
  public hasSalarieUpdate: boolean;
  // Prélèvement à la source
  public prelevementSource: string;
  // Salaire brut
  public brut: string;
  // Salaire net à payer
  public netPayer: string;
  // Cotisations patronales
  public cotisationsPatronales: string;
  // Coût employeur
  public coutEmployeur: string;
  // Frais traitement
  public fraisTraitement: string;
  // Coût total
  public total: string;
  // 
  public chatId: number;
  // 
  public checkEngine: boolean;
  // 
  public couverteParCI98 : boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.ci98 = false;
    this.contratId = 0;
    this.codeContrat = 0;
    this.projetId = 0;
    this.rubriques = [];
    this.variables = [];
    this.synthesePaie = new SynthesePaie();
    this.modifiedPaie = new ModifiedPaie();
    this.cotisations = [];
    this.simuData = new SimuData();
    this.salarieId = 0;
    this.statut = PaieStatuts.NONE;
    this.valide = false;
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = new Date(1901,1,1,0,0,0,0);
    this.exoApprentis = null;
    this.dateReglement = null;
    this.datePaiement = null;
    this.salarie = '';
    this.etablissement = '';
    this.approvedAt = null;
    this.cancelledAt = null;
    this.userCompleted = false;
    this.salarieCompleted = false;
    this.toSubmit = false;
    this.hasUserUpdate = false;
    this.hasSalarieUpdate = false;
    this.prelevementSource = '';
    this.brut = '';
    this.netPayer = '';
    this.cotisationsPatronales = '';
    this.coutEmployeur = '';
    this.fraisTraitement = '';
    this.total = '';
    this.chatId = 0;
    this.checkEngine = false;
    this.couverteParCI98  = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Paie): Paie {
    const newPaie: Paie = new Paie();
    newPaie.id = obj.id;
    newPaie.ci98 = obj.ci98;
    newPaie.contratId = obj.contratId;
    newPaie.codeContrat = obj.codeContrat;
    newPaie.projetId = obj.projetId;
    newPaie.rubriques = JSON.parse(JSON.stringify(obj.rubriques));
    newPaie.variables = JSON.parse(JSON.stringify(obj.variables));
    newPaie.synthesePaie = JSON.parse(JSON.stringify(obj.synthesePaie));
    newPaie.modifiedPaie = JSON.parse(JSON.stringify(obj.modifiedPaie));
    newPaie.cotisations = JSON.parse(JSON.stringify(obj.cotisations));
    newPaie.simuData = JSON.parse(JSON.stringify(obj.simuData));
    newPaie.salarieId = obj.salarieId;
    newPaie.statut = obj.statut;
    newPaie.valide = obj.valide;
    newPaie.dateDebut = new Date(obj.dateDebut);
    newPaie.dateFin = new Date(obj.dateFin);
    newPaie.exoApprentis = obj.exoApprentis;
    newPaie.dateReglement = obj.dateReglement ? new Date(obj.dateReglement) : null;
    newPaie.datePaiement = obj.datePaiement ? new Date(obj.datePaiement) : null;
    newPaie.salarie = obj.salarie;
    newPaie.etablissement = obj.etablissement;
    newPaie.approvedAt = obj.approvedAt ? new Date(obj.approvedAt) : null;
    newPaie.cancelledAt = obj.cancelledAt ? new Date(obj.cancelledAt) : null;
    newPaie.userCompleted = obj.userCompleted;
    newPaie.salarieCompleted = obj.salarieCompleted;
    newPaie.toSubmit = obj.toSubmit;
    newPaie.hasUserUpdate = obj.hasUserUpdate;
    newPaie.hasSalarieUpdate = obj.hasSalarieUpdate;
    newPaie.prelevementSource = obj.prelevementSource;
    newPaie.brut = obj.brut;
    newPaie.netPayer = obj.netPayer;
    newPaie.cotisationsPatronales = obj.cotisationsPatronales;
    newPaie.coutEmployeur = obj.coutEmployeur;
    newPaie.fraisTraitement = obj.fraisTraitement;
    newPaie.total = obj.total;
    newPaie.chatId = obj.chatId;
    newPaie.checkEngine = obj.checkEngine;
    newPaie.couverteParCI98  = obj.couverteParCI98 ;
    newPaie.createId = obj.createId;
    newPaie.failed = obj.failed;
    newPaie.canUpdate = obj.canUpdate;
    newPaie.canDelete = obj.canDelete;
    newPaie.display = obj.display;
    newPaie.clientId = obj.clientId;
    newPaie.notifDefType = obj.notifDefType;
    return newPaie;
  }

  public toJsonPaie (): string {
    const json = {
      ci98: this.ci98,
      contratId: this.contratId,
      codeContrat: this.codeContrat,
      projetId: this.projetId,
      rubriques: this.rubriques,
      variables: this.variables,
      synthesePaie: this.synthesePaie,
      modifiedPaie: this.modifiedPaie,
      cotisations: this.cotisations,
      simuData: this.simuData,
      salarieId: this.salarieId,
      statut: this.statut,
      valide: this.valide,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      exoApprentis: this.exoApprentis,
      dateReglement: this.dateReglement ? new Date (this.dateReglement).toString() : this.dateReglement,
      datePaiement: this.datePaiement ? new Date (this.datePaiement).toString() : this.datePaiement,
      salarie: this.salarie,
      etablissement: this.etablissement,
      approvedAt: this.approvedAt ? new Date (this.approvedAt).toString() : this.approvedAt,
      cancelledAt: this.cancelledAt ? new Date (this.cancelledAt).toString() : this.cancelledAt,
      userCompleted: this.userCompleted,
      salarieCompleted: this.salarieCompleted,
      toSubmit: this.toSubmit,
      hasUserUpdate: this.hasUserUpdate,
      hasSalarieUpdate: this.hasSalarieUpdate,
      prelevementSource: this.prelevementSource,
      brut: this.brut,
      netPayer: this.netPayer,
      cotisationsPatronales: this.cotisationsPatronales,
      coutEmployeur: this.coutEmployeur,
      fraisTraitement: this.fraisTraitement,
      total: this.total,
      chatId: this.chatId,
      checkEngine: this.checkEngine,
      couverteParCI98 : this.couverteParCI98 ,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromPaie (obj: Paie): void {
    this.id = obj.id;
    this.ci98 = obj.ci98;
    this.contratId = obj.contratId;
    this.codeContrat = obj.codeContrat;
    this.projetId = obj.projetId;
    this.rubriques = obj.rubriques;
    this.variables = obj.variables;
    this.synthesePaie = obj.synthesePaie;
    this.modifiedPaie = obj.modifiedPaie;
    this.cotisations = obj.cotisations;
    this.simuData = obj.simuData;
    this.salarieId = obj.salarieId;
    this.statut = obj.statut;
    this.valide = obj.valide;
    this.dateDebut = new Date(obj.dateDebut);
    this.dateFin = new Date(obj.dateFin);
    this.exoApprentis = obj.exoApprentis;
    this.dateReglement = obj.dateReglement;
    this.datePaiement = obj.datePaiement;
    this.salarie = obj.salarie;
    this.etablissement = obj.etablissement;
    this.approvedAt = obj.approvedAt;
    this.cancelledAt = obj.cancelledAt;
    this.userCompleted = obj.userCompleted;
    this.salarieCompleted = obj.salarieCompleted;
    this.toSubmit = obj.toSubmit;
    this.hasUserUpdate = obj.hasUserUpdate;
    this.hasSalarieUpdate = obj.hasSalarieUpdate;
    this.prelevementSource = obj.prelevementSource;
    this.brut = obj.brut;
    this.netPayer = obj.netPayer;
    this.cotisationsPatronales = obj.cotisationsPatronales;
    this.coutEmployeur = obj.coutEmployeur;
    this.fraisTraitement = obj.fraisTraitement;
    this.total = obj.total;
    this.chatId = obj.chatId;
    this.checkEngine = obj.checkEngine;
    this.couverteParCI98  = obj.couverteParCI98 ;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public comparePaie (value: Paie): boolean {
    return (this.toJsonPaie() == value.toJsonPaie());
  }

  public clonePaie (): Paie {
    return Paie.fromJson(this);
  }

  public createForStorePaie (): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPaie(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStorePaie (): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/paies/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPaie(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStorePaie (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/paies/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static calcul (paie: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/calcul', paie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Paie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static valid (paie: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/valid', paie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Paie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static pay (paie: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/pay', paie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Paie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static display (paie: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paies/display', paie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Paie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Paies/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Paie.fromJson(listData.reccords[0] as Paie);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Paie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Paies/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Paie.fromJson(listData.reccords[0] as Paie);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(paies: Paie[]) {
    paies.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
      item.dateReglement = item.dateReglement ? new Date(item.dateReglement) : item.dateReglement;
      item.datePaiement = item.datePaiement ? new Date(item.datePaiement) : item.datePaiement;
      item.approvedAt = item.approvedAt ? new Date(item.approvedAt) : item.approvedAt;
      item.cancelledAt = item.cancelledAt ? new Date(item.cancelledAt) : item.cancelledAt;
    })
  }
}
